import { BOARDS_HEIGHT_MAX, BOARDS_HEIGHT_MIN } from './boardsSectionTokens.js'

export function boardsResizeKeyDown(e, boardsHeightPx, setBoardsHeightPx) {
  const STEP = e.shiftKey ? 24 : 8
  let next = null
  if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = boardsHeightPx - STEP
  else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = boardsHeightPx + STEP
  else if (e.key === 'Home') next = BOARDS_HEIGHT_MIN
  else if (e.key === 'End') next = BOARDS_HEIGHT_MAX
  else if (e.key === 'PageUp') next = boardsHeightPx - 64
  else if (e.key === 'PageDown') next = boardsHeightPx + 64
  if (next == null) return false
  e.preventDefault()
  setBoardsHeightPx(Math.round(Math.min(BOARDS_HEIGHT_MAX, Math.max(BOARDS_HEIGHT_MIN, next))))
  return true
}
